import { render, staticRenderFns } from "./balance-section.vue?vue&type=template&id=90cf861c&scoped=true&"
import script from "./balance-section.vue?vue&type=script&lang=js&"
export * from "./balance-section.vue?vue&type=script&lang=js&"
import style0 from "./balance-section.vue?vue&type=style&index=0&id=90cf861c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cf861c",
  null
  
)

export default component.exports